var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7-3H4l.016-10H15l-.016 10H12Zm-5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm13-5.52V15h-3v-4.919l3 2.399Zm1.625-1.261L17 7.519V5c0-1.103-.813-2-1.813-2H3.812C2.813 3 2 3.897 2 5v10c0 .873.513 1.609 1.221 1.882C3.081 17.228 3 17.604 3 18c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h6.37A2.938 2.938 0 0 0 15 18c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1H21a1 1 0 0 0 1-1v-4a1 1 0 0 0-.375-.781Z",
    fill: "#0B3E21"
  })));
};
export default SvgCar;